import { captureException } from '@sentry/nextjs';

export interface JsonAttribute {
  name: string;
  value: any;
}

export interface FlexiEntityResponse {
  attributes: {
    jsonAttributes: JsonAttribute[];
  };
}

// Universal version (works in both server and client)
export const getMultipleFlightTrainConfig = async (): Promise<{ [key: string]: any }> => {
  try {
    const goyoloSeoHeaders = {
      Authorization: `Bearer ${process.env.VCMS_TOKEN || ''}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    };

    const apiUrl = `${process.env.VCMS_BASE_URL}/api/flexi-entities?filters%5Bslug%5D%5B$eq%5D=multiple-flight-train-config&populate=deep`;
    const response = await fetch(apiUrl, {
      headers: goyoloSeoHeaders,
      cache: 'no-store',
    });

    if (!response.ok) {
      throw new Error(`API call failed with status: ${response.status}`);
    }

    const data = await response.json();
    const responseAttributes = data?.data?.[0]?.attributes;

    if (!responseAttributes?.jsonAttributes) {
      console.error('No jsonAttributes found in response');
      return {};
    }

    // Transform jsonAttributes to object
    const jsonAttributes = (responseAttributes.jsonAttributes || []).reduce((acc: { [key: string]: any }, item: JsonAttribute) => {
      if (item?.name && item?.value !== undefined) {
        acc[item.name] = item.value;
      }
      return acc;
    }, {});

    return jsonAttributes;
  } catch (err) {
    captureException(err);
    console.log('Error fetching multiple flight train config:', err);
    return {};
  }
};
